'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPOINTED_DATE_FORMAT = 'ddd L';

exports.default = {

    getFirstDayOfTheWeek: function getFirstDayOfTheWeek(locale) {
        if (!_moment2.default) {
            return 0;
        }
        if (locale) {
            locale = locale.replace(/_/, '-'); // moment receives locales such as "fr-FR"
            return (0, _moment2.default)().locale(locale).localeData().firstDayOfWeek();
        } else {
            return (0, _moment2.default)().localeData().firstDayOfWeek();
        }
    },

    getFormattedAppointedDate: function getFormattedAppointedDate(date) {
        var formatted = '';

        if (date || date === 0) {
            if (!_moment2.default.isMoment(date)) {
                date = (0, _moment2.default)(date);
            }

            if (date.isValid()) {
                formatted = date.format(APPOINTED_DATE_FORMAT);
            }
        }

        return formatted;
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/LocaleUtils.js
// module id = 470
// module chunks = 0